import React from 'react'
import {Hero, Mission, Services, ButtonScrollToTop} from '../components';
const HomePage = () => {
    return (
        <main>
            <Hero/>
            <Mission/>
            <Services/>
            <ButtonScrollToTop />
        </main>
    )
}

export default HomePage
